// Helpers de URLs por idioma del sitio público.
//
// Estrategia (decidida con el founder): el español es el idioma por defecto y
// vive SIN prefijo en las URLs ya indexadas (/pricing, /about-us…); catalán e
// inglés van prefijados en /ca/… y /en/…. La URL es la fuente de verdad del
// idioma (ver <LangLayout> en App.tsx), no localStorage ni navigator.

import type { LandingLang } from "@/lib/i18n-landing";

export const LANDING_LANGS: LandingLang[] = ["es", "ca", "en"];
export const DEFAULT_LANG: LandingLang = "es";

// Paths que NUNCA llevan prefijo de idioma: app autenticada y utilidades de
// auth/checkout. (Las páginas legales SÍ se localizan: /privacy, /ca/privacy…)
const NON_LOCALIZED_PREFIXES = [
  "/platform",
  "/app",
  "/calendar",
  "/reset-password",
  "/unsubscribe",
  "/subscribe",
];

/** Idioma derivado del primer segmento del path. Sin prefijo conocido → "es". */
export function localeFromPath(pathname: string): LandingLang {
  const seg = pathname.split("/")[1];
  return seg === "ca" || seg === "en" ? seg : "es";
}

/** Quita el prefijo de idioma si lo hubiera. "/ca/pricing"→"/pricing", "/en"→"/". */
export function stripLocale(pathname: string): string {
  const seg = pathname.split("/")[1];
  if (seg === "ca" || seg === "en") {
    const rest = pathname.slice(seg.length + 1);
    return rest === "" ? "/" : rest;
  }
  return pathname;
}

function isLocalizable(path: string): boolean {
  if (!path.startsWith("/")) return false; // externos, mailto:, tel:, #, etc.
  return !NON_LOCALIZED_PREFIXES.some((p) => path === p || path.startsWith(p));
}

/**
 * Prefija `path` para `lang` (es = sin prefijo). Respeta hash/anchors y NO toca
 * rutas no localizables (app autenticada, legales ES, enlaces externos). Si el
 * path ya viniera con prefijo, lo normaliza primero.
 */
export function localizedPath(path: string, lang: LandingLang): string {
  if (!isLocalizable(path)) return path;
  const bare = stripLocale(path);
  if (lang === "es") return bare;
  if (bare === "/") return `/${lang}`;
  return `/${lang}${bare}`;
}
